import { SharedModule } from '$shared/shared.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FooterContactsComponent } from './footer-contacts/footer-contacts.component';
import { FooterGovComponent } from './footer-gov/footer-gov.component';
import { FooterNavComponent } from './footer-nav/footer-nav.component';
import { FooterSocialComponent } from './footer-social/footer-social.component';
import { FooterComponent } from './footer.component';
import { FooterCopyrightComponent } from './footer-copyright/footer-copyright.component';
import { FooterPaymentSystemComponent } from './footer-payment-system/footer-payment-system.component';
import { FooterLoadingComponent } from './footer-loading';

@NgModule({
  declarations: [
    FooterComponent,
    FooterSocialComponent,
    FooterContactsComponent,
    FooterGovComponent,
    FooterNavComponent,
    FooterCopyrightComponent,
    FooterPaymentSystemComponent,
  ],
  imports: [CommonModule, SharedModule, FooterLoadingComponent],
  exports: [
    FooterComponent,
    FooterSocialComponent,
    FooterContactsComponent,
    FooterGovComponent,
    FooterNavComponent,
    FooterLoadingComponent,
  ],
})
export class FooterModule {}
